import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../-LazyRoutePage"

const DeveloperProfilePage = lazy(
  () => import("../../components/DeveloperProfile/DeveloperProfilePage"),
)

export const Route = createFileRoute("/_layout/developer-profile")({
  component: DeveloperProfileRoute,
})

function DeveloperProfileRoute() {
  return (
    <LazyRoutePage>
      <DeveloperProfilePage />
    </LazyRoutePage>
  )
}
